































































































































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
import { Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class EidtDictionaryWord extends Vue {
  show = false;
  newSynonyms = "";
  newAntonyms = "";
  newExample = "";
  newFalseOption = "";
  @Prop() index!: any;
  @Prop() word!: any;
  @Prop() words!: any;
  @Prop() CategoryName!: any;
  categoriesLength: number = 0;
  copyWord = null;
  errors: any = [];
  apiForWordUpdate = "";
  @Emit("UpdateWords")
  UpdateWords() {
    return this.words;
  }
  checkRequired() {
    if (this.copyWord.bn) {
      return true;
    }
    this.errors = [];
    if (!this.copyWord.en) {
      this.errors.push("word required.");
    }
  }
  UpdateFiled() {
    this.word.en = this.copyWord.en;
    this.word.bn = this.copyWord.bn;
    this.word.description = this.copyWord.description;
    this.word.toEn = this.copyWord.toEn;
    this.word.partsOfSpeech = this.copyWord.partsOfSpeech;
    this.word.presentForm = this.copyWord.presentForm;
    this.word.pastForm = this.copyWord.pastForm;
    this.word.pastParticipleForm = this.copyWord.pastParticipleForm;
    this.word.synonyms = this.copyWord.synonyms;
    this.word.antonyms = this.copyWord.antonyms;
    this.word.examples = this.copyWord.examples;
    this.word.mockFalseOptions = this.copyWord.mockFalseOptions;
    this.word.imageUrl = this.copyWord.imageUrl;
  }
  AddSynonym() {
    if (this.newSynonyms != "") {
      this.copyWord.synonyms.push(this.newSynonyms);
    }
    this.newSynonyms = "";
  }
  AddAntonyms() {
    if (this.newAntonyms != "") {
      this.copyWord.antonyms.push(this.newAntonyms);
    }
    this.newAntonyms = "";
  }
  RemoveAntonyms(anIndex: any) {
    this.$delete(this.copyWord.antonyms, anIndex);
  }
  RemoveSynonym(synIndex: any) {
    this.$delete(this.copyWord.synonyms, synIndex);
  }
  AddFalseOption() {
    if (this.newFalseOption != "") {
      this.words[this.index].mockFalseOptions.push(this.newFalseOption);
    }
    this.newFalseOption = "";
  }
  RemoveFalseOption(optIndex: any) {
    this.$delete(this.words[this.index].mockFalseOptions, optIndex);
  }
  AddExamples() {
    if (this.newExample != "") {
      this.copyWord.examples.push(this.newExample);
    }
    this.newExample = "";
  }
  RemoveExamples(exIndex: any) {
    this.$delete(this.copyWord.examples, exIndex);
  }
  UpdateWord() {
    if (this.checkRequired()) {
      this.UpdateFiled();
      if (this.$route.name == "main.single_level") {
        this.UpdateWords();
      } else {
        const RequestedData = {
          word_id: this.word.id,
          word: this.copyWord,
        };

        this.apiForWordUpdate =
          "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/UpdateWord";

        const response = axios
          .post(this.apiForWordUpdate, RequestedData)
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Word is not updated" });
          });
        Notify({ type: "success", message: "Word updated" });
        this.UpdateWords();
      }
      this.show = false;
    }
  }
  partsOfSpeech = [
    "Noun",
    "Pronoun",
    "Verb",
    "Adjective",
    "Adverb",
    "Preposition",
    "Conjunction",
    "Interjenction",
  ];

  showPopup() {
    this.show = true;
  }
  mounted() {
    const obj = this.word;
    this.copyWord = Object.assign({}, obj);
    // console.log("copy ", copy); // { a: 1 }
  }
}
